import {NextRouter} from 'next/router'

export default function getPathname(router: NextRouter) {
  return router.pathname.replace('/_sites/[mobileOrDesktop]/[hostname]', '')
}
